import { get } from 'lodash';
import {
	editCapabilities,
	TYPE_CHAPS,
	TYPE_FASTER_PAYMENTS,
	TYPE_IFT,
	TYPE_BACS_CREDIT,
	TYPE_BACS_DEBIT,
	BACS_CREDIT_CODE,
	BACS_DEBIT_CODE,
} from '../../config/';
import { canDoBacsPayment, canDoIFTPayment, canDoChapsPayment } from '../accounts/selectors';
import { getIsLCV } from '../modes/selectors';
import { mapPaymentTypeToCapability } from './utils';

export const hasPaymentCapability = (state) => state.capabilities.hasPaymentCapability;
export const isMultiTransactions = (state) => state.capabilities.multiTransactions;
export const isAuthorisationEdit = (state) => state.capabilities.isAuthorisationEdit;
export const getEditMode = (state) => state.capabilities.editMode;

export const getPaymentTypeCapability = (state) =>
	get(state, 'capabilities.user.capabilities', [])
		.filter(({ enabled }) => enabled === true)
		.reduce((returnObj, cap) => ({ ...returnObj, [cap.capability]: cap.enabled }), {});

export const hasPaymentTypeCapability = (state) => Boolean(getPaymentTypeCapability(state));

export const calcPaymentTypeCapable = (state, paymentType) => {
	const paymentCapability = mapPaymentTypeToCapability(paymentType);
	return !!getPaymentTypeCapability(state)[paymentCapability];
};

export const canAddPaymentWhenEditing = (state) => {
	const editMode = getEditMode(state);
	return editCapabilities[editMode].add;
};

export const getAllVisiblePaymentTabs = (state) => {
	const enabledPayments = getPaymentTypeCapability(state);
	const isLCV = getIsLCV(state);
	const tabs = [];

	if (enabledPayments.FPS) {
		tabs.push({
			id: TYPE_FASTER_PAYMENTS,
		});
	}
	if (enabledPayments.BACS && (canDoBacsPayment(state, BACS_CREDIT_CODE) || isLCV)) {
		tabs.push({
			id: TYPE_BACS_CREDIT,
		});
	}
	if (enabledPayments.BACS && (canDoBacsPayment(state, BACS_DEBIT_CODE) || isLCV)) {
		tabs.push({
			id: TYPE_BACS_DEBIT,
		});
	}
	if (enabledPayments.IFT && (canDoIFTPayment(state) || isLCV)) {
		tabs.push({
			id: TYPE_IFT,
		});
	}
	if (enabledPayments.CHAPS && (canDoChapsPayment(state) || isLCV)) {
		tabs.push({
			id: TYPE_CHAPS,
		});
	}

	return tabs;
};

export const isIFTEnabled = (state) => {
	const enabledPayments = getPaymentTypeCapability(state);
	return enabledPayments.IFT;
};

export const isChapsEnabled = (state) => {
	const enabledPayments = getPaymentTypeCapability(state);
	return enabledPayments.CHAPS;
};
